/**
 * Constants for Demo Admin
 */

export const SCOPE_TYPES = [
  { value: 'CLIENT', label: 'Client (All Locations)' },
  { value: 'ORGUNIT', label: 'Org Unit (Market/Region)' },
  { value: 'LOCATION', label: 'Single Location' }
];

export const STATUS_COLORS = {
  QUEUED: '#FFA726',      // Orange
  RUNNING: '#29B6F6',     // Blue
  COMPLETED: '#66BB6A',   // Green
  FAILED: '#EF5350'       // Red
};

export const POLL_INTERVAL = 3000; // 3 seconds

export const DEFAULT_NOISE_SIGMA = 0.08;
export const DEFAULT_BASE_SEED = 12345;

export const SEASONALITY_PROFILES = [
  { value: 'flat', label: 'Flat - No seasonal variation' },
  { value: 'summer_peak', label: 'Summer Peak - June-August boost' },
  { value: 'winter_peak', label: 'Winter Peak - November-January boost' }
];

export const WEEKDAY_PROFILES = [
  { value: 'std_casual', label: 'Standard Casual - Weekend peak' },
  { value: 'tourist', label: 'Tourist Area - Strong weekend' },
  { value: 'office', label: 'Office Area - Weekday lunch business' }
];

export const PURPLE_THEME = {
  primary: '#7C3AED',
  primaryDark: '#6D28D9',
  inputHeight: '40px'
};
